import React, { useState, useEffect } from 'react';
import musicalCountsData from '../data/musicalCounts.json';

const MusicalCountsOverlay = ({ currentTime, inPanel = false, textSize = 100 }) => {
  // Create a style object for the text size
  const textSizeStyle = { fontSize: `${textSize}%` };
  const [currentCount, setCurrentCount] = useState(null);
  
  useEffect(() => {
    // Find the musical count that corresponds to the current time
    const findCurrentCount = () => {
      // Find the count that matches the current time most closely
      // We'll use a simple approach: find the count with the closest timestamp
      // that is less than or equal to the current time
      
      let closestCount = null;
      let smallestDifference = Infinity;
      
      for (const count of musicalCountsData) {
        // Only consider counts that are at or before the current time
        if (count.seconds <= currentTime) {
          const difference = currentTime - count.seconds;
          
          // If this count is closer than the previous closest, update
          if (difference < smallestDifference) {
            smallestDifference = difference;
            closestCount = count;
          }
        }
      }
      
      // Only update if we found a count and it's within 1 second of the current time
      // This prevents showing counts that are too far in the past
      if (closestCount && smallestDifference <= 1) {
        setCurrentCount(closestCount);
      } else {
        setCurrentCount(null);
      }
    };
    
    findCurrentCount();
  }, [currentTime]);
  
  if (!currentCount) {
    return null;
  }
  
  // If this component is being rendered inside the panel, use a different style
  if (inPanel) {
    return (
      <div className="panel-note">
        <div className="flex items-center">
          <div className="text-xl font-bold text-white" style={textSizeStyle}>
            <span className="mr-2">♪</span> {currentCount.count}
          </div>
        </div>
      </div>
    );
  }
  
  // Default overlay style for video
  return (
    <div className="video-overlay">
      <div className="flex items-center">
        <div className="text-2xl font-bold" style={textSizeStyle}>
          <span className="mr-2">♪</span> {currentCount.count}
        </div>
      </div>
    </div>
  );
};

export default MusicalCountsOverlay;
